import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\45\\s\\src\\apps\\vdsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import './ServicesHeader.css';
import React from 'react';
import { get } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import { useHistory } from 'react-router-dom';
import { tealiumClickFunc, getLastPartInURL } from '../../utils/tealium';
var ServicesHeader = function ServicesHeader(_ref) {
  var fields = _ref.fields,
    params = _ref.params;
  var history = useHistory();
  var _React$useState = React.useState(''),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    category = _React$useState2[0],
    setCategory = _React$useState2[1];
  var data = fields.data;
  var _React$useState3 = React.useState([]),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    searchResults = _React$useState4[0],
    setSearchResults = _React$useState4[1];
  var _React$useState5 = React.useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    algoliaModule = _React$useState6[0],
    setAlgoliaModule = _React$useState6[1];
  var _fields$data = fields.data,
    clickCategoryAnalytics = _fields$data.clickCategoryAnalytics,
    categorySelectedAnalytics = _fields$data.categorySelectedAnalytics,
    serviceSelectedAnalytics = _fields$data.serviceSelectedAnalytics;
  React.useEffect(function () {
    import(/* webpackChunkName: "AlgoliaModule" */'../../utils/algolia').then(function (mod) {
      setAlgoliaModule(mod.default);
    });
  }, []);
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var language = String(sitecoreContext && sitecoreContext.language);
  var defaultInfoTitle = get(data, 'item.pageTitle.jss.value');
  var defaultInfoText = get(data, 'item.pageIntro.jss.value');
  var _React$useState7 = React.useState({
      infoTitle: defaultInfoTitle,
      infoText: defaultInfoText
    }),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    infoSectionData = _React$useState8[0],
    setInfoSectionData = _React$useState8[1];
  if (!fields) {
    console.warn('ServicesHeader component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, " [ServicesHeader component is empty: please provide data source]");
    }
    return null;
  }
  var helperText = get(data, 'item.settingsItem.targetItem.explainerText.value');
  var serviceCategoryPlaceholderText = get(data, 'item.settingsItem.targetItem.serviceCategoryPlaceholderText.value');
  var servicePlaceholderText = get(data, 'item.settingsItem.targetItem.servicePlaceholderText.value');
  var categories = get(data, 'item.settingsItem.targetItem.listOfTags.targetItems', []);
  var categoryChangeHandler = function categoryChangeHandler(e) {
    if (!algoliaModule) {
      console.warn('Algolia module is not loaded');
      return;
    }
    tealiumClickFunc(categorySelectedAnalytics, e.currentTarget.options[e.currentTarget.selectedIndex].getAttribute('value'));
    var item = e.currentTarget.options[e.currentTarget.selectedIndex];
    var heading = item.getAttribute('data-heading');
    var text = item.getAttribute('data-text');
    var taxonomy = item.getAttribute('value');
    var indexNameSuffix = get(data, 'item.settingsItem.targetItem.indexName.targetItem.indexName.value');
    setCategory(e.currentTarget.options[e.currentTarget.selectedIndex].getAttribute('value'));
    algoliaModule.getIndex(indexNameSuffix).then(function (index) {
      var searchOptions = {
        facetFilters: algoliaModule.getFiltersFromCheckboxes({
          tags: [taxonomy],
          _language: [language]
        })
      };
      return index.search(searchOptions);
    }).then(function (_ref2) {
      var hits = _ref2.hits;
      setSearchResults(hits);
      setInfoSectionData({
        infoTitle: heading,
        infoText: text
      });
    }).catch(function (error) {
      console.error(error);
    });
  };
  var subcategoryChangeHandler = function subcategoryChangeHandler(e) {
    var url = e.currentTarget.value;
    tealiumClickFunc(serviceSelectedAnalytics, [category, getLastPartInURL(e.currentTarget.value)]);
    history.push(url);
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter']
  }, /*#__PURE__*/React.createElement("div", {
    className: "header--service"
  }, /*#__PURE__*/React.createElement("div", {
    className: "overlay-search"
  }), /*#__PURE__*/React.createElement("div", {
    className: "hs-top theme-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-topbot"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "hs-box"
  }, !!defaultInfoTitle && /*#__PURE__*/React.createElement("h1", {
    className: "h2 hs__title"
  }, defaultInfoTitle), /*#__PURE__*/React.createElement("p", {
    className: "desk__desc"
  }, helperText), /*#__PURE__*/React.createElement("div", {
    className: "select-div"
  }, /*#__PURE__*/React.createElement("label", {
    className: "accessibility-hidden-text",
    htmlFor: "select_dd_service1"
  }, serviceCategoryPlaceholderText), /*#__PURE__*/React.createElement("select", {
    className: "select-service",
    id: "select_dd_service1",
    name: "select",
    onChange: categoryChangeHandler,
    defaultValue: "",
    onClick: function onClick() {
      tealiumClickFunc(clickCategoryAnalytics);
    }
  }, /*#__PURE__*/React.createElement("option", {
    className: "default",
    value: "",
    disabled: true
  }, serviceCategoryPlaceholderText), categories && categories.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      "data-heading": item.serviceCategorySubheading.value,
      "data-text": item.serviceCategoryDescription.value,
      "data-taxonomy": item.taxonomyType.value,
      "data-name": item.name,
      value: item.fullName.value,
      key: item.name
    }, item.serviceCategoryName.value);
  }))), /*#__PURE__*/React.createElement("div", {
    className: "select-div select-div-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "accessibility-hidden-text",
    htmlFor: "select_dd_service2"
  }, servicePlaceholderText), /*#__PURE__*/React.createElement("select", {
    className: "select-service",
    id: "select_dd_service2",
    name: "select-2",
    onChange: subcategoryChangeHandler,
    disabled: searchResults.length ? false : true,
    defaultValue: ""
  }, /*#__PURE__*/React.createElement("option", {
    className: "default",
    value: "",
    disabled: true
  }, servicePlaceholderText), searchResults && searchResults.map(function (item) {
    return /*#__PURE__*/React.createElement("option", {
      value: item.url
    }, item.pagename);
  })))))))), /*#__PURE__*/React.createElement("div", {
    className: "module-group no-padding-top hs__desc"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "desc-item"
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-medium title"
  }, infoSectionData.infoTitle), /*#__PURE__*/React.createElement("p", null, infoSectionData.infoText)))))));
};
var StyledWrapper = function StyledWrapper(_ref3) {
  var children = _ref3.children,
    rtl = _ref3.rtl,
    anchorUrlParameter = _ref3.anchorUrlParameter;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: "".concat(rtl ? rtlStyles : ltrStyles)
  }, children);
};
var ltrStyles = "lshsdxq";
var rtlStyles = "r1yvb7fz";
export default ServicesHeader;